import React from 'react';

export const BallpitBackground: React.FC = () => {
  const balls = [
    { size: 'w-32 h-32', color: 'bg-red-400', top: '10%', left: '15%', delay: '0s', duration: '8s' },
    { size: 'w-24 h-24', color: 'bg-blue-400', top: '60%', left: '75%', delay: '1s', duration: '10s' },
    { size: 'w-40 h-40', color: 'bg-yellow-400', top: '40%', left: '50%', delay: '2s', duration: '12s' },
    { size: 'w-28 h-28', color: 'bg-green-400', top: '70%', left: '20%', delay: '0.5s', duration: '9s' },
    { size: 'w-36 h-36', color: 'bg-secondary-400', top: '20%', left: '80%', delay: '1.5s', duration: '11s' },
    { size: 'w-20 h-20', color: 'bg-pink-400', top: '85%', left: '60%', delay: '2.5s', duration: '7s' },
    { size: 'w-32 h-32', color: 'bg-orange-400', top: '50%', left: '10%', delay: '3s', duration: '13s' },
    { size: 'w-24 h-24', color: 'bg-teal-400', top: '15%', left: '40%', delay: '0.8s', duration: '9.5s' },
    { size: 'w-28 h-28', color: 'bg-primary-400', top: '75%', left: '85%', delay: '1.2s', duration: '10.5s' },
    { size: 'w-36 h-36', color: 'bg-cyan-400', top: '35%', left: '25%', delay: '2.2s', duration: '11.5s' },
  ];

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-gradient-to-br from-gray-50 via-blue-50 to-secondary-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {balls.map((ball, index) => (
        <div
          key={index}
          className={`absolute ${ball.size} ${ball.color} rounded-full opacity-60 dark:opacity-10 blur-sm`}
          style={{
            top: ball.top,
            left: ball.left,
            animation: `ballFloat ${ball.duration} ease-in-out infinite`,
            animationDelay: ball.delay,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }}
        />
      ))}

      {/* Additional floating balls for depth */}
      <div className="absolute top-30 left-45 w-16 h-16 bg-lime-400 rounded-full opacity-40 blur-md animate-float"></div>
      <div className="absolute top-55 left-65 w-20 h-20 bg-rose-400 rounded-full opacity-40 blur-md animate-float" style={{ animationDelay: '1.8s' }}></div>
      <div className="absolute top-25 left-70 w-12 h-12 bg-amber-400 rounded-full opacity-40 blur-md animate-float" style={{ animationDelay: '3.5s' }}></div>

      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 bg-white/30 dark:bg-gray-900/60 backdrop-blur-[2px]"></div>
    </div>
  );
};
